import { Button, Flex } from '@mantine/core';
import { useState } from 'react';

import { useUpdateCorrelationId } from '@admin/hooks';
import { TextInput } from '@components';

export const UpdateCorrelationId = ({ selectedSystem, selectedLRN, selectedMRN, selectedTransitGroup, correlationId }) => {
  const [newCorrelationId, setNewCorrelationId] = useState('');
  const updateCorrelationIdMutation = useUpdateCorrelationId();

  const handleUpdateCorrelationId = () => {
    const body: any = {
      system: selectedSystem.value,
      newCorrelationId: newCorrelationId.trim(),
    };
    if (correlationId?.length) {
      body.oldCorrelationId = correlationId;
    } else if (selectedMRN?.length) {
      body.mrn = selectedMRN;
      if (selectedSystem?.value === 'ncts') {
        body.transitGroup = selectedTransitGroup;
      }
    } else if (selectedLRN?.length) {
      body.lrn = selectedLRN;
    }
    updateCorrelationIdMutation.mutate({ body });
    setNewCorrelationId('');
  };

  const renderIdentifierInput = () => {
    if (correlationId?.length) return <TextInput value={correlationId} disabled label="Current Correlation ID" w={400} />;
    return <></>;
  };

  return (
    <Flex gap={16} align="flex-start">
      <Button type="button" onClick={handleUpdateCorrelationId} disabled={newCorrelationId.trim() === ''} variant="outline" size="lg">
        Update Correlation ID
      </Button>
      {renderIdentifierInput()}
      <TextInput value={newCorrelationId} onChange={(e) => setNewCorrelationId(e.target.value)} label="New Correlation ID" w={400} />
    </Flex>
  );
};
